import { render } from "./PitchDeck.vue?vue&type=template&id=5a880ad0"
import script from "./PitchDeck.vue?vue&type=script&lang=js"
export * from "./PitchDeck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__